<template>
  <v-app style="background-color:white">
    <!-- <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon color="#64f5a9" size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs> -->

    <v-card flat class="form-container">
      <v-card-title>
        <span class="title">
          <v-icon color="#212121" size="28">receipt</v-icon>&nbsp;Invoice&nbsp;
        </span>
        <!-- <v-divider v-if="users.length < 2" color="#64f5a9" vertical class="mr-3 ml-3"></v-divider> -->
        <v-btn color="#e53935" depressed to="/createInvoice" dark small class="txt_dec">
          Create
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          flat
          v-model="search"
          append-icon="search"
          color="black"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="tableHeader" :items="list" :search="search">
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.billNo }}</td>
          <td class="text-xs-left">{{ props.item.invoiceDate }}</td>
          <td class="text-xs-left">{{ props.item.fullName }}</td>
          <td class="text-xs-left">{{ props.item.taxableAmount }}</td>
          <td class="text-xs-left">{{ props.item.gst }}</td>
          <td class="text-xs-left">{{ props.item.totalAfterTax }}</td>
          <td class="justify-left layout px-4">
            <v-tooltip top color="#212121">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small color="#212121" class="mr-1" @click="onEdit(props.item)">edit</v-icon>
              </template>
              <span>Edit / View</span>
            </v-tooltip>
            
            <!-- <v-tooltip top color="#e53935">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small color="#e53935" class="mr-1" @click="onDelete(props.item)">delete</v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip> -->
          </td>
          
        </template>
        <v-alert
          v-slot:no-results
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
    </v-card>
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      roleType: sessionStorage.roles,
      list: [],
      search: "",
      tableHeader: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Bill No", value: "billNo" },
        { text: "Invoice Date", value: "invoiceDate" },
        { text: "Customer Name", value: "fullName" },
        { text: "Taxable Amount", value: "taxableAmount" },
        { text: "GST", value: "gst" },
        { text: "Total Amount", value: "totalAfterTax" },
        { text: "Action", value: "action" }
      ]
    };
  },

  methods: {
    getData() {
      this.axios
        .get(config.API + "Invoices", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.list = res.data;
          this.$Progress.finish();
          this.getData();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },
   // :rows-per-page-items="[10,15,20]"
    onDelete(item) {
      // alert(item.id);
      if (confirm("You want to delete !!")) {
        this.axios
          .delete(config.API + `Invoices/${item.Id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Successfully deleted");
            //this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    onEdit(item) {
      this.$router.push(`editInvoice/${item.id}`);
    }
  },

  mounted() {
    this.getData();
    this.$Progress.start();
  }
};
</script>
<style lang="css" scoped>
.bckgrnds {
  background-image: url('https://backgroundcheckall.com/wp-content/uploads/2018/10/school-background-image-8.jpg') !important;
  background-size:cover !important;
}
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.txt_dec:hover {
    text-decoration: none !important;
}
</style>